module.exports = __webpack_public_path__ + "static/media/arper.3362cb3a.svg";